import { useCallback, useRef, useState } from 'react';

export function usePaddleWebhookSecretForm(onSave: (secret: string) => Promise<void>, onSaved: () => void) {
  const [secret, setSecret] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const inFlight = useRef(false);
  const changeSecret = useCallback((value: string) => { setSecret(value); setError(null); }, []);
  const save = useCallback(async () => {
    if (inFlight.current) return;
    const value = secret.trim();
    if (!/^pdl_ntfset_\S+$/.test(value) || value.length > 1024) {
      setError('Enter the signing secret from this environment’s Paddle notification destination.');
      return;
    }
    inFlight.current = true; setSaving(true); setError(null);
    try {
      await onSave(value);
      setSecret(''); onSaved();
    } catch (failure) {
      setError(failure instanceof Error ? failure.message : 'Could not save the secret. Please try again.');
    } finally { inFlight.current = false; setSaving(false); }
  }, [secret, onSave, onSaved]);
  return { secret, changeSecret, saving, error, save };
}
